































import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import AboutTextImg from '../components/AboutTextImg.vue';
import FullImgText from '../components/FullImgText.vue';
import {
    pageData
} from '../store/pageData';
import CeoBlock from '../components/Home/CeoBlock.vue';
import TeamBlock from '../components/TeamBlock.vue';
import HistoryBlock from '../components/HistoryBlock.vue';
import AwardCard from '../components/AwardCard.vue';
import TitleDoubleText from '../components/TitleDoubleText.vue';
import SingleImg from '../components/SingleImg.vue';
import SingleTitle from '../components/SingleTitle.vue';
import IndustryTextimg from '../components/IndustryTextimg.vue';
import CounterFull from '../components/CounterFull.vue';
import Certification from '../components/Certification.vue';
import ColorTitleText from '../components/ColorTitleText.vue';
import FullimgFloatText from '../components/FullimgFloatText.vue';
import LtRtImgText from '../components/LtRtImgText.vue';
import DoubleImgBlock from '../components/DoubleImgBlock.vue';
import SingleTitleText from '../components/SingleTitleText.vue';
import TitleText from '../components/TitleText.vue';
import {
    TimelineMax,
    TweenLite,
    Power1,
    TweenMax,
    Expo,
    Power2,
    Power3,
    Power4
} from "gsap";
import AOS from "aos";
import TitleDoubleTextLink from '../components/TitleDoubleTextLink.vue';
import ImageSlider from '../components/ImageSlider.vue';
import IndustryMap from '../components/IndustryMap.vue';
@Component({
    name: "TeamBasicPage",
    components: {
        featured_content_block: AboutTextImg,
        featured_content_summary_block: FullImgText,
        ceo_message: CeoBlock,
        member_list_block: TeamBlock,
        history_tab_block: HistoryBlock,
        title_subtitle_text_alignment_image: AwardCard,
        title_text_block: TitleDoubleText,
        single_image: SingleImg,
        single_title: SingleTitle,
        richtext: IndustryTextimg,
        industry_year_progress_block: CounterFull,
        title_image_list: Certification,
        bottom_title_richtext: ColorTitleText,
        title_text_image: FullimgFloatText,
        title_richtext_image: LtRtImgText,
        double_image_block: DoubleImgBlock,
        non_parallel_title_richtext_block: SingleTitleText,
        parallel_title_richtext_block: TitleText,
        title_text_block_cta: TitleDoubleTextLink,
        slider: ImageSlider,
        map_and_contact: IndustryMap
    }
})
export default class TeamBasicPage extends Vue {
    @Prop() pageData!: pageDataType | null;
    public HOST: string = HOST;
    public created() {
        AOS.init();
    }
    public heroimganim(): void {
        const {
            imgoverlay
        } = this.$refs
        TweenLite.delayedCall(1.5, overlay);

        function overlay() {
            TweenMax.to(imgoverlay, .03, {
                opacity: .4,
                ease: Power2.easeOut
            });
        }
        var heroimganim = new TimelineMax({});
        heroimganim
            .to(imgoverlay, .01, {
                opacity: 0,
            })

            .staggerFrom(".banner-wrap img", 1.1, {
                delay: .2,
                autoAlpha: 0,
                scale: 2,
                height: '10%',
                yPercent: 10,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.1)
            .to('.banner-text', .01, {
                overflow: 'hidden'
            })
            .staggerFrom('.banner-text h1', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .1, '-=.05')
            .staggerFrom('.banner-text p', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .2, '-=.3')
            .to('.banner-text', .01, {
                clearProps: 'all'
            });

    }
    public mounted() {
        this.heroimganim();
    }
}
